import { Select, SelectProps } from '@mui/material'
import React from 'react'

const SelectWrapper = React.forwardRef<JSX.Element, SelectProps>((props, ref) => (
  <Select {...props} ref={ref} />
))

export default SelectWrapper
